import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./HotelAccount.css";

function HotelAccount() {
  const navigate = useNavigate();

  // Later you can fetch this from backend
  const hotel = {
    name: "Green Leaf Hotel",
    email: "greenleaf@gmail.com",
    phone: "9876543210",
    address: "Pune, Maharashtra",
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      {/* HEADER */}
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <h1>SaveBite</h1>
          </div>

          <nav className="navigation">
            <Link to="/hotel/dashboard" className="nav-link">Dashboard</Link>
            <Link to="/hotel/add-surplus" className="nav-link">Add Surplus</Link>
            <Link to="/hotel/donationevent" className="nav-link">Donation</Link>
            
            <button className="dashboard-button">My Account</button>
          </nav>
        </div>
      </header>

      {/* ACCOUNT PAGE */}
      <div className="account-page">
        <div className="account-card">
          <h2 className="account-title">My Account</h2>
          <p className="account-subtitle">Hotel Profile Details</p>

          <div className="account-info">
            <div><span>Hotel Name:</span> {hotel.name}</div>
            <div><span>Email:</span> {hotel.email}</div>
            <div><span>Phone:</span> {hotel.phone}</div>
            <div><span>Address:</span> {hotel.address}</div>
          </div>

          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </>
  );
}

export default HotelAccount;
